<template lang="">
  <div class="home">
    <div
      class="f1"
      :style="{
        backgroundImage: 'url(' + baseUrl + '/matthew.png' + ')',
      }"
    >
      <div class="f1_box" ref="f1">
        <div class="f1_title1">OBJECTIVE</div>
        <div class="f1_title2">Tech Inspires Financial Inclusion</div>
      </div>
    </div>
    <div class="f2">
      <div class="f2_box">
        <div class="f2_bg"></div>
        <img :src="baseUrl + '/shutterstocki.png'" />
        <div class="right_box">
          <div class="f2_title">KEY RESULTS</div>
          <div class="f2_list">
            <img src="../assets/img/flow.png" />
            No more than 1,000 people achieve an annual turnover of 100 billion
            U.S. dollars
          </div>
          <div class="f2_list">
            <img src="../assets/img/member.png" />
            Covers 1 billion users
          </div>
          <div class="f2_list">
            <img src="../assets/img/duce.png" />
            Progressively cut down interest rates or charges since 2022
          </div>
        </div>
      </div>
    </div>
    <div
      class="f3"
      :style="{
        backgroundImage: 'url(' + baseUrl + '/shutterstocko.png' + ')',
      }"
    >
      <div class="f3_box" ref="f3">
        <div class="f3_title1">CORE VALUE</div>
        <div class="f3_title2">Simple, Practical, Integrity</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {
    this.$store.commit("SetStatus", "1");
    this.$nextTick(() => {});
  },
  mounted() {
    window.addEventListener("scroll", this.handelScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handelScroll);
  },
  methods: {
    handelScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop * 0.5 < 345) {
        this.$refs.f1.style.transform = "translateY(" + scrollTop * 0.5 + "px)";
      }
      let scrolltop1 = this.$refs.f3.getBoundingClientRect().top;
      let clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;

      if (scrolltop1 < clientHeight) {
        this.$refs.f3.style.transform =
          "translateY(" + (clientHeight - scrolltop1) * 0.5 + "px)";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  .f1 {
    width: 100%;
    height: 945px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    .f1_box {
      width: 1200px;
      margin: 0 auto;
      padding-top: 440px;
      .f1_title1 {
        font-size: 62px;
        font-family: "oh";
        font-weight: normal;
        color: #f43d3d;
        margin-bottom: 26px;
      }
      .f1_title2 {
        height: 32px;
        font-size: 28px;
        font-family: "or";
        font-weight: normal;
        color: #9fa0a5;
        line-height: 32px;
        margin-left: 110px;
      }
    }
  }
  .f2 {
    width: 100%;
    padding: 284px 0 256px;
    background-color: #fff;
    .f2_box {
      width: 1200px;
      margin: 0 auto;
      position: relative;
      img {
        display: inline-block;
        vertical-align: top;
        width: 670px;
        height: 404px;
        z-index: 4;
        position: relative;
      }
      .f2_bg {
        width: 670px;
        height: 404px;
        z-index: 2;
        left: -36px;
        top: -36px;
        position: absolute;
        background-color: #f43d3d;
      }
      .right_box {
        display: inline-block;
        padding: 46px 0 0 60px;
        vertical-align: top;
        width: 470px;
        .f2_title {
          height: 54px;
          font-size: 62px;
          font-family: "oh";
          font-weight: normal;
          color: #f43d3d;
          margin-bottom: 60px;
        }
        .f2_list {
          padding-left: 70px;
          font-size: 18px;
          font-family: "or";
          font-weight: normal;
          color: #28283c;
          line-height: 30px;
          margin-bottom: 40px;
          position: relative;
          img {
            position: absolute;
            width: 46px;
            height: auto;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }
  }
  .f3 {
    width: 100%;
    height: 945px;
    padding-top: 210px;
    box-sizing: border-box;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    opacity: 0.92;
    .f3_box {
      width: 1200px;
      margin: 0 auto;
      .f3_title1 {
        font-size: 62px;
        font-family: "oh";
        font-weight: normal;
        color: #f43d3d;
        margin-bottom: 30px;
      }
      .f3_title2 {
        padding-left: 100px;
        font-size: 29px;
        font-family: "or";
        font-weight: normal;
        color: #ffffff;
        line-height: 47px;
      }
    }
  }
}
</style>
